exports = module.exports = require("../../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".avatar-uploader .ant-upload {\n  width: 100px !important;\n  height: 100px !important;\n  border-radius: 50%;\n  padding: 0 !important;\n  overflow: hidden;\n}\n.avatar-uploader .ant-upload .avatar {\n  width: 100px;\n  height: 100px;\n}\n.homework {\n  width: 100%;\n  height: auto;\n  border-radius: 10px;\n  margin-bottom: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?{"importLoaders":1}!./node_modules/_postcss-loader@2.0.8@postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/_less-loader@4.1.0@less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/upload/index.less
// module id = 987
// module chunks = 0